// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Utils = require("../../../utils/Utils.bs.js");
var Js_array = require("rescript/lib/js/js_array.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var GraphQLHelpers = require("../../common/GraphQL/GraphQLHelpers.bs.js");
var GraphQLConverter = require("../../common/GraphQLConverter.bs.js");
var ConversationEvent = require("../types/ConversationEvent.bs.js");
var Conversations__Types = require("../types/Conversations__Types.bs.js");
var Conversations__ContextCard = require("../components/Conversations__ContextCard.bs.js");

function decode(obj) {
  var partial_arg = GraphQLConverter.Helpers.$$const(obj.participants);
  var partial_arg$1 = GraphQLConverter.Helpers.$$const(Belt_List.fromArray(Belt_Option.getWithDefault(obj.events, [])));
  var partial_arg$2 = GraphQLConverter.Helpers.$$const(Belt_List.fromArray(Belt_Array.keepMap(obj.messages, Utils.Result.toOption)));
  var partial_arg$3 = GraphQLConverter.Helpers.ok(obj.context);
  var partial_arg$4 = function (param) {
    return GraphQLConverter.Helpers.flatMap((function (param) {
                  return GraphQLConverter.Helpers.source(obj, param);
                }), partial_arg$3, param);
  };
  var partial_arg$5 = function (param) {
    return GraphQLConverter.Helpers.flatMap(partial_arg$4, partial_arg$2, param);
  };
  var partial_arg$6 = function (param) {
    return GraphQLConverter.Helpers.flatMap(partial_arg$5, partial_arg$1, param);
  };
  return GraphQLConverter.Helpers.run(function (context, messages, events, participants) {
                return {
                        id: {
                          TAG: /* Existing */0,
                          _0: obj.id
                        },
                        visibility: obj.visibility,
                        readOnly: Belt_Option.getWithDefault(obj.readOnly, false),
                        anonymous: obj.anonymous,
                        context: context,
                        participants: participants,
                        messages: messages,
                        events: events
                      };
              })(function (param) {
              return GraphQLConverter.Helpers.flatMap(partial_arg$6, partial_arg, param);
            });
}

var ppx_printed_query = "fragment FullConversation on Conversation   {\nid  \nvisibility  \nreadOnly  \nanonymous  \n..." + Conversations__ContextCard.Context.ConversationContext.name + "   \n..." + Conversations__Types.Participants.ConversationParticipants.name + "   \nmessages  {\n..." + Conversations__Types.Message.ConversationMessage.name + "   \n}\n\nevents  {\n..." + ConversationEvent.ConversationEvent.name + "   \n}\n\n}\n" + ConversationEvent.ConversationEvent.query + Conversations__ContextCard.Context.ConversationContext.query + Conversations__Types.Message.ConversationMessage.query + Conversations__Types.Participants.ConversationParticipants.query;

function parse(value) {
  var value$1 = value["visibility"];
  var tmp = value$1 === "PUBLIC" ? "PUBLIC" : "PRIVATE";
  var value$2 = value["readOnly"];
  var value$3 = value["anonymous"];
  var value$4 = value["messages"];
  var value$5 = value["events"];
  return decode({
              id: value["id"],
              visibility: tmp,
              readOnly: !(value$2 == null) ? value$2 : undefined,
              anonymous: GraphQLHelpers.defaultToFalse(!(value$3 == null) ? value$3 : undefined),
              context: Curry._1(Conversations__ContextCard.Context.ConversationContext.parse, value),
              participants: Curry._1(Conversations__Types.Participants.ConversationParticipants.parse, value),
              messages: Js_array.map((function (value) {
                      return Curry._1(Conversations__Types.Message.ConversationMessage.parse, value);
                    }), value$4),
              events: !(value$5 == null) ? Js_array.map((function (value) {
                        return ConversationEvent.ConversationEvent.parse(value);
                      }), value$5) : undefined
            });
}

function ret_type(f) {
  return {};
}

var MT_Ret = {};

var FullConversation = {
  ppx_printed_query: ppx_printed_query,
  query: ppx_printed_query,
  parse: parse,
  name: "FullConversation",
  ret_type: ret_type,
  MT_Ret: MT_Ret
};

var idToString = Conversations__Types.Conversation.idToString;

var unreadByUser = Conversations__Types.Conversation.unreadByUser;

var countUnread = Conversations__Types.Conversation.countUnread;

var Fragments = Conversations__Types.Conversation.Fragments;

var Fragment;

exports.idToString = idToString;
exports.unreadByUser = unreadByUser;
exports.countUnread = countUnread;
exports.Fragments = Fragments;
exports.decode = decode;
exports.FullConversation = FullConversation;
exports.Fragment = Fragment;
/* Utils Not a pure module */
